const mutations = {
  SET_COMPANY_UNITS(state, companyUnits) {
    state.companyUnits = companyUnits;
  },
  SET_TOKEN_SERVICE(state, tokenService) {
    state.tokenService = tokenService;
  },
  PUSH_CONTROL_TO_REFRESH(state, controlName) {
    state.controlsNeedRefresh.push(controlName)
  },
  REMOVE_CONTROL_FROM_REFRESH(state, controlName) {
    let index = state.controlsNeedRefresh.findIndex(f => f == controlName)
    if (index >= 0) {
      state.controlsNeedRefresh.splice(index, 1)
    }
  },
}

export default mutations